import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'ramda';
import { defaultProps } from 'recompose';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import connect from 'app/libs/connect';
import Text from 'app/components/layout/Text.styled';
import { MIDDLE } from 'app/analytics/constants/positions';
import Heading from 'app/components/layout/Heading.styled';
import BasicLink from 'app/components/Links/BasicLink.styled';
import ProductCta from 'app/features/landing/components/ProductCta';
import S from 'app/features/pricingPromo/landing/components/heroBlock/HeroBlock.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import { PRICING_PROMO_TOS_URL } from 'app/features/pricingPromo/landing/components/heroBlock/constants';
import { FAN_PACK_FREE_TRIAL_SKU } from 'app/constants/freeTrial';
import {
  productCurrency,
  productPriceAmount,
} from 'app/features/plans/selectors';

const UI = ({ productCurrency, productPriceAmount }) => (
  <S.HeroBlock>
    <S.BackgroundDiv />
    <S.StarsImage
      data-t="stars-background"
      src={`${window.etp.config.assetsUrl}img/pricingPromo/starsSet.png`}
      srcSet={`${window.etp.config.assetsUrl}img/pricingPromo/starsSet@2x.png 2x`}
      alt="stars"
    />
    <S.Content data-t="hero-block">
      <Heading size="l" as={S.Title}>
        <FormattedMessage id="pricing_promo_landing_heroblock_title" />
      </Heading>
      <Heading size="s" as={S.Subtitle}>
        <FormattedMessage id="pricing_promo_landing_heroblock_subtitle" />
      </Heading>
      <S.Subscribe
        type="six"
        position={MIDDLE}
        testId="hero-subscribe-button"
        sku={FAN_PACK_FREE_TRIAL_SKU}
        textKey="pricing_promo_landing_subscribe_button"
        isWideOnMobile
        as={ProductCta}
      >
        <FormattedMessage id="pricing_promo_landing_subscribe_button" />
      </S.Subscribe>
      <Text size="m" as={S.Description}>
        <FormattedMessage
          id="pricing_promo_landing_heroblock_description"
          values={{
            price: (
              <FormattedNumber
                style="currency"
                value={productPriceAmount}
                currency={productCurrency}
              />
            ),
            tosLink: (
              <BasicLink
                testId="terms-of-service-link"
                as={LocalizedLink}
                to={PRICING_PROMO_TOS_URL}
              >
                <FormattedMessage id="pricing_promo_landing_heroblock_tos_link" />
              </BasicLink>
            ),
          }}
        />
      </Text>
    </S.Content>
    <S.HimeImage
      data-t="hero-image"
      src={`${window.etp.config.assetsUrl}img/pricingPromo/hime.png`}
      srcSet={`${window.etp.config.assetsUrl}img/pricingPromo/hime@2x.png 2x`}
      alt="Hime"
    />
  </S.HeroBlock>
);

UI.propTypes = {
  productPriceAmount: PropTypes.string,
  productCurrency: PropTypes.string,
};

UI.defaultProps = {
  productPriceAmount: '0',
  productCurrency: 'USD',
};

UI.displayName = 'Heroblock';

const state = { productPriceAmount, productCurrency };

const Heroblock = compose(
  defaultProps({ sku: FAN_PACK_FREE_TRIAL_SKU }),
  connect(state),
)(UI);

export { UI };

export default Heroblock;
